import OperatingModeRequestModel from '../../../generated/types/model/request/OperatingModeRequestModel';

export default class OperatingModeRequestViewModel extends OperatingModeRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
